import { put, call, takeEvery, fork, all } from "redux-saga/effects";

const initialState = {
	query: "",
	isSearching: false,
	searchBarId: ""
};

/////////
//types
export const types = {
	SEARCH_BAR_SUBMIT: "components/searchbar/SEARCH_BAR_SUBMIT",
	SEARCH_BAR_UPDATED: "components/searchbar/SEARCH_BAR_UPDATED",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.SEARCH_BAR_UPDATED:
				return { ...state, ...action.payload };
			case types.SEARCH_BAR_SUBMIT:
				return { ...state, ...action.payload };

			default:
				return state;
		}
	}
};

////////
//actions
export const actions = {

	searchTextChanged(query, params) {
		return {
			type: types.SEARCH_BAR_UPDATED,
			payload: {
				...params,
				query: query.text,
				searchBarId: query.searchBarId
			}
		};
	},

	searchSubmit(query, params) {
		return {
			type: types.SEARCH_BAR_SUBMIT,
			payload: {
				...params,
				query: query.text,
				searchBarId: query.searchBarId
			}
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/SearchBar/redux.js